
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCreditCardDialog extends Serenity.EntityDialog<PsCreditCardRow, any> {
        protected getFormKey() { return PsCreditCardForm.formKey; }
        protected getIdProperty() { return PsCreditCardRow.idProperty; }
        protected getLocalTextPrefix() { return PsCreditCardRow.localTextPrefix; }
        protected getNameProperty() { return PsCreditCardRow.nameProperty; }
        protected getService() { return PsCreditCardService.baseUrl; }
        protected getDeletePermission() { return PsCreditCardRow.deletePermission; }
        protected getInsertPermission() { return PsCreditCardRow.insertPermission; }
        protected getUpdatePermission() { return PsCreditCardRow.updatePermission; }

        protected form = new PsCreditCardForm(this.idPrefix);

    }
}